import { Html } from "@eusoft/webapp-jsx/components/Html";


const svgString = `<svg

   viewBox="0 0 1600 1600"
   version="1.1"
   class="logo"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg">
  <path
     style="fill:none;fill-opacity:1;stroke:currentColor;stroke-width:111.475;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:none"
     d="M 295.7375,869.08387 V 323.7375 h 991.187 v 976.2199 L 564.03169,1297.129 V 565.98375 H 1022.3351 V 939.11548 H 763.89335"
     id="circuit" />
  <circle
     style="fill:currentColor;fill-opacity:1;stroke:none;stroke-width:127.28;stroke-linecap:round;stroke-linejoin:miter;stroke-dasharray:none"
     id="letter-point"
     cx="816.04236"
     cy="934.40448"
     r="108" />
</svg>`;



export function Logo() {
    return <Html src={svgString} />;
}